import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { marqueeItems } from '../data/content';
export function Marquee() {
  const reduceMotion = useReducedMotion();
  const items = [...marqueeItems, ...marqueeItems];
  const row = <div className="flex shrink-0 items-center" data-id="element-169" data-mp="2ijxbo0vd1x0s">
      {items.map((item, index) => <span key={`${item}-${index}`} className="flex items-center whitespace-nowrap px-6 text-sm font-extrabold uppercase tracking-[0.16em] text-ink" data-id="element-170" data-mp="2dlm5c049y4nb" data-mpi={index}>
          {item}
          <span className="ml-6 inline-block h-1.5 w-1.5 rounded-full bg-ink/40" aria-hidden="true" data-id="element-171" data-mp="368qbw9j0mr17" />
        </span>)}
    </div>;
  return <div className="w-full overflow-hidden border-y-2 border-ink bg-volt py-3.5" aria-hidden="true" data-id="element-172" data-mp="318u6c5uo6rjj">
      {reduceMotion ? <div className="flex justify-center" data-id="element-173" data-mp="2x8ab57tnpy01">{row}</div> : <motion.div className="flex w-max" animate={{
      x: ['0%', '-50%']
    }} transition={{
      duration: 26,
      ease: 'linear',
      repeat: Infinity
    }} data-id="element-174" data-mp="1pvhyzkzpbqsm">
          {row}
          {row}
        </motion.div>}
    </div>;
}